import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useMutation } from "@apollo/react-hooks";
import { Alert, Button, Icon, Modal, message } from "antd";
import gql from "fraql";
import { isNil } from "lodash";

const RESEND_CONFIRMATION = gql`
  mutation RegistrationSubmissionReSendConfirmationAlert_ResendConfirmation($regSubmissionId: ID!) {
    resendConfirmationEmail(RegSubmissionId: $regSubmissionId) {
      result
    }
  }
`;

function RegistrationSubmissionReSendConfirmationAlert({ regSubmissionId }) {

  const [resend, { data, loading }] = useMutation(RESEND_CONFIRMATION);

  useEffect(()=>{
    if (!isNil(data)){
      if (!isNil(data.resendConfirmationEmail) && data.resendConfirmationEmail.result === "ok"){
        message.success("Email sent");
      }
    }
  },[data]);

  const handleResendClicked = (tempData) => {
    Modal.confirm({
      title: "Confirm Send",
      content: (
        <>
          <p>
            This will send an email to the person who completed this registration submission.
          </p>
          <p>
            As the sender, you will also receive a BCC to your email.
          </p>
          <p>Are you sure you want to do this?</p>
        </>
      ),
      okText: "Yes, SEND",
      onOk() {
        resend(tempData);
      },
    });
  }

  return (
    <>
      <br /> 
      <Alert type="info" style={{textAlign: "center"}} message={
        <div>
          <div style={{marginBottom: "10px", fontWeight: "600"}}>Re-send Confirmation Email</div>
          <div><Button disabled={loading} onClick={()=>handleResendClicked({ variables: { regSubmissionId }})}><Icon type="mail" /> Send Now!</Button></div>
        </div>
      } />
    </>
  );
  
}

RegistrationSubmissionReSendConfirmationAlert.propTypes = {
  regSubmissionId: PropTypes.string,
};

RegistrationSubmissionReSendConfirmationAlert.defaultProps = {
  regSubmissionId: null,
};

export default RegistrationSubmissionReSendConfirmationAlert;
